import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-funnel-leads',
  templateUrl: './new-funnel-leads.component.html',
  styleUrls: ['./new-funnel-leads.component.scss']
})
export class NewFunnelLeadsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
